import React from "react";

import { AccountContainer, AccountContent, AccountName, CurrentChip, StyledAvatar, SwitchingToChip } from "./AccountBox.styles";

type AccountBoxProps = {
  accountName: string;
  isCurrent: boolean;
};

export const AccountBox: React.FC<AccountBoxProps> = ({ accountName, isCurrent }) => {
  const ChipComponent = isCurrent ? CurrentChip : SwitchingToChip;
  const chipLabel = isCurrent ? "Current" : "Switching to";

  return (
    <AccountContainer isCurrent={isCurrent}>
      <AccountContent>
        <StyledAvatar name={accountName} stringColor variant="rounded" />
        <AccountName isCurrent={isCurrent} noWrap>
          {accountName}
        </AccountName>
      </AccountContent>
      <ChipComponent label={chipLabel} size="small" sx={{ marginLeft: "auto" }} />
    </AccountContainer>
  );
};
